import { ENV } from './env';

const KEY = 'immoaktas.staleReloadAt';

/**
 * After a deploy an open tab still asks for the old route chunks; the host answers them with index.html, so the lazy
 * import fails and every page it touches breaks. That is not a bug of the page: load the new build once.
 */
export function isStaleBuildError(error: unknown) {
  const m = error instanceof Error ? `${error.name} ${error.message}` : String(error);
  return /dynamically imported module|Importing a module script failed|error loading dynamically imported|module script.*MIME|ChunkLoadError|Unable to preload CSS/i.test(m);
}

/** Reloads once per minute at most, so a really broken build ends in the error view instead of a reload loop. */
export function reloadForNewBuild(): boolean {
  try {
    const last = Number(sessionStorage.getItem(KEY) ?? 0);
    if (Date.now() - last < 60_000) return false;
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch {
    // no storage (private mode): still reload, the browser's own cache rules prevent a loop in practice
  }
  window.location.reload();
  return true;
}

/** Vite fires this when a lazy chunk (or its CSS) cannot be loaded. */
export function watchStaleBuild() {
  window.addEventListener('vite:preloadError', (e) => {
    if (reloadForNewBuild()) e.preventDefault();
  });
}

/** Render errors caught by a route boundary go to Sentry (when configured) and the console. */
export function reportRenderError(error: unknown, componentStack?: string | null) {
  console.error('[boundary]', error, componentStack);
  if (ENV.sentryDsn) void import('@sentry/react').then((S) => S.captureException(error, { extra: { componentStack } }));
}
